/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_ItalianInputs */



/**
* | output |
* | --- |
* | "Italian" |
*
* @param {Speechmatics_Target_Language_ItalianInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_italian = /** @type {((inputs?: Speechmatics_Target_Language_ItalianInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_ItalianInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Italien")
	if (locale === "de") return /** @type {LocalizedString} */ ("Italienisch")
	if (locale === "it") return /** @type {LocalizedString} */ ("Italiano")
	if (locale === "ru") return /** @type {LocalizedString} */ ("итальянский")
	if (locale === "es") return /** @type {LocalizedString} */ ("italiano")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("意大利语")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イタリア語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इतालवी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("italiano")
	return /** @type {LocalizedString} */ ("Italian")
});